import { DataType } from "../../../../form/typings";
import { editableControlOptions } from "../../../../form/component-schema";
import i18n from "../../../i18n";
export default {
    $id: "logic",
    type: DataType.Object,
    $ref: editableControlOptions.$id,
    properties: {
        widgetType: {
            type: DataType.String,
            title: i18n.t('dataitem.ControlType').toString(),
        },
        dataItemType: {
            type: DataType.String,
            title: i18n.t('dataitem.DataItemType').toString(),
        },
        defaultValue: {
            type: DataType.Boolean,
            title: i18n.t('dataitem.DefaultValue').toString(),
            default: true,
        },
        dataLinkage: {
            type: DataType.String,
            title: i18n.t('dataitem.DataLinkage').toString(),
        },
        labelVisible: {
            type: DataType.Boolean,
            title: i18n.t('dataitem.LabelVisible').toString(),
            default: true,
        },
        readonlyCondition: {
            type: DataType.String,
            title: i18n.t('dataitem.ReadonlyConditions').toString(),
        },
    },
};
